query DocumentShowQuery($id: ID!) {
  document(id: $id) {
    id
    title
    text
    slug
    type
    isPublished
    version
    date
    versionIds
    versions {
      id
      version
      date
      createdAt
    }
    platform {
      id
      title
    }
    language {
      id
      title
    }
    createdAt
    updatedAt
    deletedAt
    deleted
  }
}
